export const STATUT_EN_COURS = 'En cours'

export const STATUT_ANNULEE = 'Annulée'

export const STATUT_EN_ATTENTE = 'En attente de réponse'

export const STATUT_REALISEE = 'Réalisée'

export const STATUT_NON_REALISEE = 'Non réalisée'

export const ACCEPTEE = 'Acceptée'

export const STATUT_REFUSEE = 'Refusée'



// WEBPACK FOOTER //
// ./src/utils/demandeStatut.js